import * as React from 'react';
import { useState } from 'react';

/** Redux Packages. */
import { useSelector, useDispatch } from 'react-redux';

/** Internal Components */
import TabPanel from 'shared/ui/TabPanel';
import UpdateTabs from 'shared/ui/Tabs';

import { actionMap } from './ActionMap';
import NewShipmentContainer from './NewShipmentContainer';

export default function NewShipmentHouse({ dialogConfig, setGridEditingKeys, gridApiRef, tabTitles, setTabTitles }) {
    /** Get the dispatch function from Redux to send actions to the store. */
    const dispatch = useDispatch();

    /** State to track the currently selected tab. */
    const [selectedTab, setSelectedTab] = useState(0);
    /** State to manage tab editing for UpdateTabs component. */
    const [editIndex, setEditIndex] = useState(-1);
    const [isChange, setIsChange] = useState(false);

    /** New shipment form data. */
    const formData = useSelector((state) => state[dialogConfig.formState]);
    /** HBL list. */
    const hblList = formData[dialogConfig.keyName[0]];
    /** Handle changing the selected tab. */
    const handleChangeTab = (event, newValue) => setSelectedTab(newValue);

    /** Handle adding a new tab by incrementing the last tab's id. */
    const handleAddTab = () => {
        const newId = hblList.length ? hblList[hblList.length - 1].id + 1 : 1;
        dispatch(
            actionMap[dialogConfig.reducerActionsHBL[0]]({
                id: newId,
                [dialogConfig.keyName[1]]: [],
                [dialogConfig.keyName[2]]: '',
                [dialogConfig.keyName[3]]: '',
                [dialogConfig.keyName[4]]: '',
                reference: '',
            })
        );
    };

    /** Handle changing the title. */
    const handleChangeTabTitle = (index, tabId) => (e) => {
        setTabTitles((prev) => ({ ...prev, [tabId]: e.target.value }));
        setIsChange(true);
    };

    /** Handle to delete tab value. */
    const handleDeleteTab = (tab) => {
        if (hblList.length > 1) {
            dispatch(actionMap[dialogConfig.reducerActionsHBL[2]](tab.id));
        } else {
            window.alert('At least one HBL/HAWB must be provided. ');
        }
    };

    /** Handle double click to edit tab title */
    const handleDoubleClick = (index) => {
        setEditIndex(index);
    };

    /** Handle key down events */
    const handleKeyDown = (event, tabId, originalTitle) => {
        if (event.key === 'Enter') {
            setEditIndex(-1);
            if (isChange && tabTitles[tabId] !== undefined) {
                dispatch(
                    actionMap[dialogConfig.reducerActionsHBL[1]]({
                        id: tabId,
                        newTitle: tabTitles[tabId].toUpperCase(),
                    })
                );
            }
        } else if (event.key === 'Escape') {
            setEditIndex(-1);
            setTabTitles((prev) => ({ ...prev, [tabId]: originalTitle }));
        }
    };

    /** Handle blur events */
    const handleBlur = (tabId, originalTitle) => {
        setEditIndex(-1);
        if (isChange && tabTitles[tabId] !== undefined) {
            dispatch(
                actionMap[dialogConfig.reducerActionsHBL[1]]({
                    id: tabId,
                    newTitle: tabTitles[tabId].toUpperCase(),
                })
            );
        }
    };

    return (
        <>
            <UpdateTabs
                value={selectedTab}
                label={dialogConfig.keyName[2]}
                tabsData={hblList}
                tabTitles={tabTitles}
                editIndex={editIndex}
                isChange={isChange}
                handleChange={handleChangeTab}
                handleDoubleClick={handleDoubleClick}
                handleChangeTabTitle={handleChangeTabTitle}
                handleKeyDown={handleKeyDown}
                handleBlur={handleBlur}
                handleDeleteTab={handleDeleteTab}
                handleAddTab={handleAddTab}
                tabsStyle={{
                    '& .MuiButtonBase-root': {
                        p: 0,
                        border: 'none',
                    },
                }}
                tabStyle={{
                    '& .MuiInputBase-root': {
                        px: 0.5,
                    },
                }}
            />
            {hblList.map((tab, index) => (
                <TabPanel key={`panel-${tab.id}`} value={selectedTab} index={index} boxStyle={{ px: 0.5, py: 0 }}>
                    <NewShipmentContainer
                        tabId={tab.id}
                        dialogConfig={dialogConfig}
                        setGridEditingKeys={setGridEditingKeys}
                        gridApiRef={gridApiRef}
                    />
                </TabPanel>
            ))}
        </>
    );
}
